// Paleta determinística de colores por categoría (color distinto por categoría).
const PALETTE = [
  '#0EA5E9', '#8B5CF6', '#EC4899', '#F59E0B', '#10B981', '#EF4444',
  '#14B8A6', '#6366F1', '#F97316', '#84CC16', '#06B6D4', '#D946EF',
  '#22C55E', '#EAB308', '#A855F7', '#3B82F6',
];

export function categoryColor(key) {
  if (!key) return '#64748B';
  const s = String(key);
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

// Estilo para chips de filtro (activo = relleno; inactivo = tinte)
export function catChipStyle(key, active) {
  const c = categoryColor(key);
  return active
    ? { backgroundColor: c, color: '#fff', borderColor: c }
    : { backgroundColor: `${c}1A`, color: c, borderColor: `${c}55` };
}

// Estilo para la etiqueta de categoría en tarjetas/lista
export function catBadgeStyle(key) {
  const c = categoryColor(key);
  return { backgroundColor: `${c}1A`, color: c, borderColor: `${c}44` };
}
